/**
 * 安全解析 JSON 字符串
 * 兼容类似工具函数DFWebUtilsTools.getCatchAddress()返回null的场景
 */
export function safeJsonParse(str: string | null) {
  if (!str) return null;

  try {
    return JSON.parse(str);
  } catch (e) {
    return null;
  }
}
